module.exports = __webpack_public_path__ + "img/appAsset--customer-address-ax.12f479ff.svg";